const PlayerTableDiscard = ({ discard = {} }) => {
  if (!discard.total) return '-';

  return discard.total;
};

export default PlayerTableDiscard;
